"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanitizePrice = exports.round = void 0;
const lodash_1 = require("lodash");
const round = (num, fractionDigits = 0) => {
    return Math.round(num * Math.pow(10, fractionDigits)) / Math.pow(10, fractionDigits);
};
exports.round = round;
const sanitizePrice = (num, isCent) => {
    if (!(0, lodash_1.isFinite)(num))
        return num;
    if (isCent) {
        return (0, exports.round)(num);
    }
    else {
        return (0, exports.round)(num, 2);
    }
};
exports.sanitizePrice = sanitizePrice;
//# sourceMappingURL=math.js.map